<template>
  <footer class="bg-gray-200 p-4">
    <div class="container mx-auto text-center">
      <a
        href="#"
        class="mx-2 hover:text-gray-500"
        @click.prevent="openModal('tos')"
      >Terms of Service</a>
      <ModalComponent
        :show="modals.tos"
        @update:show="updateModal('tos', $event)"
      >
        <TermsOfService />
      </ModalComponent>
      <a
        href="#"
        class="mx-2 hover:text-gray-500"
        @click.prevent="openModal('privacy')"
      >Privacy Policy</a>
      <ModalComponent
        :show="modals.privacy"
        @update:show="updateModal('privacy', $event)"
      >
        <p>
          This system was created by a junior developer <br>
          who lacks the knowledge and understanding to <br>
          perform complex and invasive data collection.<br>
          Your secrets are safe with us.<br>
        </p>
      </ModalComponent>
      <RouterLink
        class="mx-2 hover:text-gray-500"
        to="/"
      >
        Home
      </RouterLink>
    </div>
  </footer>
</template>

<script>
import ModalComponent from '@/DSAReportComponents/ModalComponent.vue';
import TermsOfService from '@/DSAReportComponents/TermsOfService.vue';
import { RouterLink } from 'vue-router';

export default {
  components: {
    ModalComponent,
    TermsOfService,
    RouterLink
  },
  data() {
    return {
      modals: {
        tos: false,
        privacy: false
      }
    };
  },
  methods: {
    openModal(type) {
      this.modals[type] = true;
    },
    updateModal(type, value) {
      this.modals[type] = value;
    },
  }
};
</script>
